import { Route } from "react-router";
import { CoApplicantAddress } from "@lending/pages/Common/CoApplicants/Address";
import { CoApplicantAddressAsk } from "@lending/pages/Common/CoApplicants/AddressAsk";
import { CoApplicantAsk } from "@lending/pages/Common/CoApplicants/Ask";
import { CoApplicantDetails } from "@lending/pages/Common/CoApplicants/Details";
import { CoApplicantIncome } from "@lending/pages/Common/CoApplicants/Income";
import { EmploymentDetails } from "@lending/pages/Common/EmploymentDetails";
import { CoApplicantGuard } from "./guards/CoApplicantGuard";

interface CoApplicantRoutesProps {
  productType: "personal_loans" | "credit_cards" | "vehicle_loans";
  fallbackPath: string;
}

const getCoApplicantRoutes = ({ productType, fallbackPath }: CoApplicantRoutesProps) => (
  <Route
    path="co-applicant"
    element={<CoApplicantGuard productType={productType} fallbackPath={fallbackPath} />}
  >
    <Route path="ask" element={<CoApplicantAsk />} />
    <Route path="details" element={<CoApplicantDetails />} />
    <Route path="address-ask" element={<CoApplicantAddressAsk />} />
    <Route path="address" element={<CoApplicantAddress />} />
    <Route path="income" element={<CoApplicantIncome />} />
    <Route path="employment-details" element={<EmploymentDetails applicantType="co-applicant" />} />
  </Route>
);

export { getCoApplicantRoutes };
